module.exports = __webpack_public_path__ + "img/popup_icon_stamp.fc120ae9.png";